import { createFileRoute } from '@tanstack/react-router'

import { connectionQuery, eventsQuery, settingsQuery } from '../lib/queries'
import { Connection } from '../screens/Connection'

export const Route = createFileRoute('/connection')({
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(connectionQuery()),
      context.queryClient.ensureQueryData(eventsQuery()),
      context.queryClient.ensureQueryData(settingsQuery()),
    ]),
  component: Connection,
})
